module.exports = __webpack_public_path__ + "static/catherine-goodman-423b5e74526f600b8ec9e18184bd3e01.png";